import React, { useRef } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useMap } from '../../context/MapContext';
import './LayerCard.css';

function PencilIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 20h9"/>
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  );
}

function LayerCard({ layer, onCustomize }) {
  const { removeWmsLayer, toggleWmsVisibility } = useMap();
  const [removing, setRemoving] = React.useState(false);
  const timerRef = useRef(null);

  React.useEffect(() => () => clearTimeout(timerRef.current), []);

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: layer.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  function handleRemove() {
    setRemoving(true);
    timerRef.current = setTimeout(() => removeWmsLayer(layer.id), 200);
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`layer-card${isDragging ? ' layer-card--dragging' : ''}${removing ? ' layer-card--removing' : ''}`}
    >
      <button
        className="layer-card-remove"
        onClick={handleRemove}
        title="Remover camada"
        aria-label={`Remover ${layer.name}`}
      >
        ✕
      </button>

      <span
        className="layer-card-handle"
        {...attributes}
        {...listeners}
        title="Arrastar para reordenar"
        aria-label="Arrastar para reordenar"
      >
        ⠿
      </span>

      <button
        className={`layer-card-eye${layer.visible === false ? ' layer-card-eye--off' : ''}`}
        onClick={() => toggleWmsVisibility(layer.id)}
        title={layer.visible === false ? 'Exibir camada' : 'Ocultar camada'}
        aria-label={layer.visible === false ? `Exibir ${layer.name}` : `Ocultar ${layer.name}`}
        aria-pressed={layer.visible !== false}
      >
        {layer.visible === false ? <EyeOffIcon /> : <EyeIcon />}
      </button>

      <span className="layer-card-name" title={layer.name}>
        {layer.name}
      </span>

      <button
        className="layer-card-edit"
        onClick={onCustomize}
        title="Personalizar camada"
        aria-label={`Personalizar ${layer.name}`}
      >
        <PencilIcon />
      </button>
    </div>
  );
}

export default LayerCard;
